import { observer } from "mobx-react";
import { toJS } from "mobx";
import numeral from "numeral";
import AnalyticsStore from "src/stores/AnalyticsStore";
import { Spinner } from "src/components/-common";
import { BarChart, ChartWrapper, Collection, SummaryNumber } from "src/components/-common/-charts";
import EnrollmentTable from "../../EnrollmentTable";

function SB() {
  const { loadingCurriculum: loading, curriculum, currentAndUpcoming } = AnalyticsStore || {};
  const { SB: data, capacity: rawCapacity } = toJS(curriculum) || {};
  const { SB: tableData } = toJS(currentAndUpcoming) || {};

  const { "Sound Beginnings": capacity } = rawCapacity || {};

  if (loading) {
    return (
      <Collection title="Sound Beginnings">
        <ChartWrapper width={12} height={2}>
          <div className="loading-container">
            <Spinner alt />
          </div>
        </ChartWrapper>
      </Collection>
    );
  }

  const totalEnrollments = data?.map(d => d?.["Sound Beginnings"] || 0)?.reduce((acc, next) => acc + next, 0);
  const enrolledCapacity = numeral(totalEnrollments / capacity).format("0.0%");

  return (
    <Collection title="Sound Beginnings" rows={2}>
      <ChartWrapper width={8} height={2}>
        <div className="chart-title">Enrollments for This Year by Registration Date</div>
        <BarChart data={data} colors={["var(--Sound-Beginnings)"]} />
      </ChartWrapper>
      <ChartWrapper width={4} height={1}>
        <div className="chart-title">Total Enrollments This Year</div>
        <SummaryNumber value={totalEnrollments} />
      </ChartWrapper>
      <ChartWrapper width={4} height={1}>
        <div className="chart-title">Enrolled Capacity</div>
        <SummaryNumber value={enrolledCapacity} text />
      </ChartWrapper>
      <ChartWrapper width={12} height={2}>
        <div className="chart-title">Current & Upcoming Enrollments</div>
        <EnrollmentTable data={tableData} color={["var(--Sound-Beginnings)"]} />
      </ChartWrapper>
    </Collection>
  );
}

export default observer(SB);
